import { render, staticRenderFns } from "./usermanage.vue?vue&type=template&id=c5b5cee4&scoped=true&"
import script from "./usermanage.vue?vue&type=script&lang=js&"
export * from "./usermanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b5cee4",
  null
  
)

export default component.exports